const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/bizmanagement/' +
    path +
    (subPath ? `/${subPath}` : '/index'));

const routes = {
  path: '/bizmanagement',
  component: AppLayout,
  meta: {
    title: 'meetingplan',
    hidden: true
  },
  redirect: 'budget',
  children: [
    {
      path: 'budget',
      name: 'bizmanagement-budget',
      meta: {
        title: 'bizmanagement.budget'
      },
      component: _import('budget')
    },
    {
      path: 'strategy',
      name: 'bizmanagement-strategy',
      meta: {
        title: 'bizmanagement.strategy'
      },
      component: _import('strategy')
    },
    {
      path: 'domainresult',
      name: 'bizmanagement-domain-result',
      meta: {
        title: 'bizmanagement.domain-result'
      },
      component: _import('domainresult')
    },
    {
      path: 'hospitallevel',
      name: 'bizmanagement-hospital-level',
      meta: {
        title: 'bizmanagement.hospital-level'
      },
      component: _import('hospitallevel')
    },
    {
      path: 'speakerlevel',
      name: 'bizmanagement-speaker-level',
      meta: {
        title: 'bizmanagement.speaker-level'
      },
      component: _import('speakerlevel')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/bizManagement.js